import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { environment } from 'src/environments/environment';

export interface AiServiceCall {
  url: string;
  headers: HttpHeaders;
  body: Record<string, unknown>;
}

export interface AiServiceCallOptions {
  sessionId?: string;
  includeEmail?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AiRequestUtilsService {
  constructor(
    private userStateService: UserStateService,
    private companyStateService: CompanyStateService,
  ) {}

  buildCall(endpoint: string, opts?: AiServiceCallOptions): AiServiceCall {
    const url = `${environment.AI_SERVICE_URL}/${endpoint}`;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${environment.AI_SERVICE_API_KEY}`,
      'Content-Type': 'application/json',
    });

    const body: Record<string, unknown> = {
      token: this.userStateService.getAccessToken().access_token,
      companyId: this.companyStateService.getSelectedCompanyId(),
    };

    if (opts?.sessionId) body.sessionId = opts.sessionId;
    if (opts?.includeEmail) {
      body.payload = { email: this.userStateService.getUserEmail() };
    }

    return { url, headers, body };
  }
}
